import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";  // Import Firestore

const firebaseConfig = {
  apiKey: "AIzaSyDRxmON-vW-MyX5JwX6x-2nUDNnFMRo-pI",
  authDomain: "databolta-hai.firebaseapp.com",
  projectId: "databolta-hai",
  storageBucket: "databolta-hai.appspot.com",  // Fix the incorrect storage URL
  messagingSenderId: "568629483905",
  appId: "1:568629483905:web:f159b59a51209459c2f080",
  measurementId: "G-ESVXXT568P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const db = getFirestore(app);  // Initialize Firestore

// Export Firebase services
export { auth, googleProvider, db }; // ✅ Now exporting `db`
